import React from "react";

function RenderPostCaption({caption}:{
    caption: string
}) {
    return <RenderTextWithLinksAndHashtags text={caption || ''} />
}


function RenderTextWithLinksAndHashtags({ text }: { text: string }) {
    const parts = text.split(/(#[\w-]+|https?:\/\/[^\s]+)/g);
    return (
        <span style={{whiteSpace:"pre-line"}}>
            {parts.map((part, index) => {
                if (/^https?:\/\/[^\s]+$/.test(part)) {
                    return <a className={"text-blue-600"} target={"_blank"} key={index} href={part}>{part}</a>;
                } else if (/^#[\w-]+$/.test(part)) {
                    return <span key={index} className={"text-blue-600"}>{part}</span>;
                } else {
                    return <span key={index}>{part}</span>;
                }
            })}
        </span>
    );
}

export default RenderPostCaption;
